import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-bg-secondary border-t border-border-subtle">
      <div className="container-landing pt-24 pb-8">
        {/* 4-column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16">
          {/* Col 1: Logo + tagline + social */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-text-primary mb-3">
              <img src="/logo.png" alt="Koji" className="h-9 w-auto logo-animated" style={{ filter: 'drop-shadow(0 0 4px rgba(229,172,65,0.3))' }} />
            </Link>
            <p className="text-sm text-text-secondary mb-4">
              Self-evolving copy & design by Coded Motion
            </p>
            <div className="flex items-center gap-3">
              <span className="text-text-tertiary text-xs" title="Social links coming soon">Twitter / GitHub / LinkedIn</span>
            </div>
          </div>

          {/* Col 2: Product */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-4">Product</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Features', to: '/#features' },
                { label: 'Pricing', to: '/#pricing' },
                { label: 'Documentation', to: '/docs' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-text-secondary hover:text-accent-primary hover:translate-x-0.5 transition-all inline-block">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Resources */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-4">Resources</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Blog', to: '/blog' },
                { label: 'API Reference', to: '/docs' },
                { label: 'Community', to: '/docs' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-text-secondary hover:text-accent-primary hover:translate-x-0.5 transition-all inline-block">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Company */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-4">Company</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'About', to: '/#about' },
                { label: 'Contact', to: 'mailto:hello@codedmotion.studio' },
                { label: 'Legal', to: '/privacy' },
              ].map((link) => (
                <li key={link.label}>
                  {link.to.startsWith('mailto:') ? (
                    <a href={link.to} className="text-sm text-text-secondary hover:text-accent-primary hover:translate-x-0.5 transition-all inline-block">
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.to} className="text-sm text-text-secondary hover:text-accent-primary hover:translate-x-0.5 transition-all inline-block">
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-border-subtle flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-text-tertiary">
            &copy; 2026 Coded Motion. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-text-tertiary hover:text-accent-primary transition-colors">
              Privacy
            </Link>
            <span className="text-text-tertiary">&middot;</span>
            <Link to="/terms" className="text-xs text-text-tertiary hover:text-accent-primary transition-colors">
              Terms
            </Link>
            <span className="text-text-tertiary">&middot;</span>
            <a href="mailto:hello@codedmotion.studio" className="text-xs text-text-tertiary hover:text-accent-primary transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
